/**
 * Costanti per la gestione dei file HEIC/HEIF
 */

export const HEIC_MIME_TYPES = ['image/heic', 'image/heif'] as const;

export const HEIC_EXTENSIONS = ['.heic', '.heif'] as const;

/**
 * Brand identifiers per i file HEIC/HEIF nel ftyp box
 * @see https://nokiatech.github.io/heif/technical.html
 */
export const HEIC_BRAND_IDENTIFIERS = [
  'heic', // HEIC - HEVC coded image
  'heix', // HEIC - HEVC coded image (extended)
  'hevc', // HEVC coded video
  'hevx', // HEVC coded video (extended)
  'mif1', // Multi-Image Format
  'msf1', // Multi-Image Format Sequence
] as const;

/** Offset del ftyp signature nel file */
export const FTYP_OFFSET = 4;

/** Bytes minimi necessari per verificare l'header HEIC */
export const HEIC_HEADER_SIZE = 12;

/** Qualità di default per la conversione in JPEG (0-1) */
export const JPEG_CONVERSION_QUALITY = 0.9;
